import { CommissionsTable } from './components';

const CommissionsTab = () => (
  <CommissionsTable />
);

export { CommissionsTab };
